export const VERSION_INFO = { tag: '2.84.0', branch: '2.84.0', commit: 'fac2dc56e56e1eb969461754fbded93b917cbbdf', date: 'Thu Jan 15 12:20:34 UTC 2026' }
